/**
 * Auto-generated by scripts/build-docs-manifest.js — do not edit by hand.
 * Regenerate: node scripts/build-docs-manifest.js
 */
export const docPages = [
  {
    "slug": "docs-overview",
    "title": "Documentation overview",
    "excerpt": "How Racontera documentation is organized and where to find help.",
    "group": "getting-started",
    "groupLabel": "Getting started",
    "groupOrder": 10,
    "order": 10,
    "access": "public",
    "body": "Welcome to the Racontera documentation.\n\n## What you'll find here\n\n- **Getting started** — orientation and workflow basics (public).\n- **Workflows** — how research, writing, and publishing connect (public).\n- **Internal** — team-only notes (`access: auth`); visible after login under **Help** in the app.\n\n## Editing docs\n\nDocumentation lives as Markdown under `content/docs/` in the repo. Run the build manifest script (or `npm run build`) to pick up changes.\n\nSee `content/docs/README.md` for frontmatter options, including `access: public` vs `access: auth`.",
    "sourcePath": "getting-started/overview.md"
  },
  {
    "slug": "research-to-publish",
    "title": "Research to publish",
    "excerpt": "End-to-end flow from research reports through drafts to publishing.",
    "group": "workflows",
    "groupLabel": "Workflows",
    "groupOrder": 20,
    "order": 10,
    "access": "public",
    "body": "Racontera is built around a human-led pipeline:\n\n## 1. Research\n\nOpen **Research reports** and click **New research** to answer “what should I write about?” Choose a **research brief** (broad trends and gaps) or **existing content** (cluster spin-offs from an article in Racontera or an external URL). Optionally **save for recurring research** to run on a schedule. Review **research reports** and approve article ideas that match your SEO and lead-value priorities.\n\n## 2. Write\n\nApproved ideas move to the **content queue**. Open a **draft workspace** to build a source-backed research brief, outline, and article body.\n\n## 3. Publish\n\nSend approved drafts to the **publishing queue**. Push to WordPress as a draft, then mark published when live.\n\nEach stage keeps editorial judgment in your hands — the app supports the process rather than replacing it.",
    "sourcePath": "workflows/research-to-publish.md"
  },
  {
    "slug": "beta-waitlist-ops",
    "title": "Beta waitlist operations",
    "excerpt": "How to review beta signups and provision accounts.",
    "group": "internal",
    "groupLabel": "Internal",
    "groupOrder": 90,
    "order": 10,
    "access": "auth",
    "body": "This page is only listed under **Help** in the logged-in app (`access: auth`).\n\n## Review signups\n\nFrom the project root:\n\n```bash\n./venv/bin/python3 scripts/list_beta_signups.py\n```\n\n## Provision a user\n\nAfter approving a signup, create their login:\n\n```bash\n./venv/bin/python3 scripts/create_user.py\n```\n\nThere is no self-serve signup in v1 — the marketing form captures leads only.",
    "sourcePath": "internal/beta-waitlist-ops.md"
  }
];
